import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  constructor() {}

  /**
   * FormGroup has a method `markAsDirty` but it doesn't mark all its controls
   * as dirty, so this method is created.
   */
  markControlsInFormGroupDirty(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control) => {
      control.markAsDirty();

      if (control.controls) {
        this.markControlsInFormGroupDirty(control);
      }
    });
  }
}
